export default "__VITE_ASSET__DgZLH7R4__"